module.exports = __webpack_public_path__ + "img/no-cancellation-fee.440a4419.png";